import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material';

@Injectable()
export class FuseMatSidenavHelperService
{
    sidenavInstances: MatSidenav[];

    constructor()
    {
        this.sidenavInstances = [];
    }

    setSidenav(id, instance)
    {
        this.sidenavInstances[id] = instance;
    }

    getSidenav(id)
    {
        return this.sidenavInstances[id];
    }
}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/core/directives/fuse-mat-sidenav-helper/fuse-mat-sidenav-helper.service.ts